<template>
  <div>
    <template v-if="loading">
      <opq-loading>{{ loadingMessage }}</opq-loading>
    </template>
    <template v-else>
      <headline code="description"></headline>
      <v-form ref="mainForm" class="mt-6">
        <opq-text-field
          code="courriel"
          is-email
          :disabled="emailLoading"
          :loading="emailLoading"
          v-model="creationDeCompte.courriel"
          @blur="checkContactExists"
        ></opq-text-field>
        <template v-if="contactFound">
          <opq-alert code="contactTrouve" width="700"></opq-alert>
        </template>
        <v-dialog v-model="contactFoundModal" width="500">
          <v-card class="px-2 px-sm-4 py-6 pa-md-12">
            <div class="text-center">
              <v-icon x-large color="info" class="mb-4">mdi-information</v-icon>
              <div>
                <ressource code="contactTrouve"></ressource>
              </div>
            </div>
          </v-card>
        </v-dialog>
        <opq-catalogue code="sexe" v-model="creationDeCompte.sexe"></opq-catalogue>

        <div class="d-flex flex-wrap">
          <opq-text-field code="prenom" class="mr-3" v-model="creationDeCompte.prenom"></opq-text-field>
          <opq-text-field code="nom" v-model="creationDeCompte.nom"></opq-text-field>
        </div>
        <v-divider class="my-6"></v-divider>

        <opq-catalogue code="type-coordonnees" v-model="creationDeCompte.typeDeCoordonnees"></opq-catalogue>
        <opq-text-field code="organisation" v-model="creationDeCompte.organisation" v-if="estAdresseProfessionnelle"></opq-text-field>

        <div class="d-flex flex-wrap">
          <opq-text-field
            code="telephone"
            is-phone-number
            optional
            :code-pays="codePays(creationDeCompte.pays)"
            class="mr-3"
            v-model="creationDeCompte.telephone"
          ></opq-text-field>

          <opq-text-field
            code="poste"
            is-number
            optional
            v-if="estAdresseProfessionnelle"
            v-model="creationDeCompte.posteTelephonique"
          ></opq-text-field>
        </div>

        <adresse-personnelle :carteAffaire="creationDeCompte" two-columns :live="false" no-phone no-email></adresse-personnelle>

        <opq-file code="photo" v-model="creationDeCompte.photo" optional></opq-file>
        <v-btn color="#3a3838" dark large class="my-3" @click="submit" :disabled="loading || contactFound" :loading="loading">Soumettre</v-btn>
        <opq-alert v-show="showAlert" type="warning" class="mt-6" code="formulaire-incomplet" width="700"></opq-alert>
      </v-form>
    </template>
  </div>
</template>

<script>
import FormulaireBase from "@/mixins/FormulaireBase"
import CreationDeCompteModel from "@/models/CreationDeCompteModel"
import { creationCompte } from "@/plugins/services/sas"
import { contactExistByEmail } from "@/plugins/services/contacts"
import CataloguesHelpers from "@/mixins/CataloguesHelpers"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
export default {
  components: { AdressePersonnelle },
  data() {
    return {
      creationDeCompte: new CreationDeCompteModel(),
      loadingMessage: this.$t("formulaires.chargement"),
      emailLoading: false,
      contactFoundModal: false,
      contactFound: false,
      showAlert: false
    }
  },

  metaInfo() {
    return {
      title: this.$t("meta.formulaires.creationDeCompte.title")
    }
  },

  mixins: [FormulaireBase, CataloguesHelpers],

  mounted() {
    this.loadParams("creation-de-compte")
  },

  computed: {
    estAdresseProfessionnelle() {
      return this.creationDeCompte.typeDeCoordonnees == this.$valeursCatalogues.adresseProfessionnelle
    }
  },

  methods: {
    submit() {
      if (this.$refs.mainForm.validate()) {
        this.loading = true
        this.loadingMessage = this.$t("formulaires.envoiDesInformations")
        creationCompte(this.creationDeCompte)
        this.$router.push({ name: "FormulaireSoumis" })
      } else {
        this.showAlert = true
      }
    },

    checkContactExists() {
      if (this.$emailRegex.test(this.creationDeCompte.courriel)) {
        this.emailLoading = true
        contactExistByEmail(this.creationDeCompte.courriel)
          .then((res) => {
            this.contactFoundModal = res.data.found
            this.contactFound = res.data.found
          })
          .finally(() => {
            this.emailLoading = false
          })
      }
    },

    resetProvince() {
      if (this.creationDeCompte) {
        this.creationDeCompte.province = undefined
        this.$refs.province.handleChange()
      }
    }
  }
}
</script>

<style>
</style>